// components/chat/chat-input/AttachmentUploadButton.tsx
import { Paperclip } from "lucide-react";

export const AttachmentUploadButton = ({
  onFilesAdded,
}: {
  onFilesAdded: (files: File[]) => void;
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    onFilesAdded(Array.from(e.target.files));
  };

  return (
    <label htmlFor="chat-file-upload" className="cursor-pointer">
      <div className="mb-1 rounded-md p-2 text-primary/50 opacity-100 hover:bg-muted">
        <Paperclip className="-rotate-45 h-4 w-4 flex-shrink-0" />
      </div>
      <input
        id="chat-file-upload"
        type="file"
        className="hidden"
        multiple
        accept=".pdf,.doc,.docx,.txt,.ppt,.pptx,video/*,audio/*,image/*"
        onChange={handleChange}
      />
    </label>
  );
};
